export default __webpack_public_path__ + "static/media/property_204.1753fea6.png";